import { HttpClient } from '@angular/common/http';
import { Component, Input, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_accessibility from 'highcharts/modules/accessibility';
import { UniqueChartService } from '../../unique-chart.service';
import Stock from 'highcharts/modules/stock';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { BarserviceService } from '../../../../barchart/barchart/barservice.service';
import { ActivatedRoute } from '@angular/router';

Stock(Highcharts);
@Component({
  selector: 'app-funnelchart1-custom',
  templateUrl: './funnelchart1.component.html',
  styleUrls: [],
})
export class Funnelchart1ComponentCustom {
  constructor(
    private http: HttpClient,
    private uniquechartservice: UniqueChartService,
    private _customSnapshotService: CustomsnapshotService,
    public _configService: SnapshotService,
    private barService: BarserviceService,
    private route: ActivatedRoute,
  ) { }

  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;

  //parameters from snapshot-chrtparent
  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;
  @Input() showXaxisLabels: boolean = true;
  @Input() multiFunnelPopup: boolean = false;
  @Input() widgetCount: number = 0;
  @Input() widgetName: string = '';

  maxDataPoints: any = 2;
  significanceValue: any = "None";
  chartMainData: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  // ngOnInit(): void {
  //   this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
  //     this.jsondata = data[0];
  //     this.chartproperties = this.jsondata['properties'][0];
  //     this.chartproperties.decimalRoundOff=2;
  //     this.seriescolor = this.uniquechartservice.color;
  //     this.seriesgradientcolor = this.uniquechartservice.linearGradients1;
  //     this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
  //     this.plotChart(
  //       'chart-container'+this.id,
  //       this.jsondata['data'],
  //       this.chartproperties
  //     );
  //   });
  // }
  private subscriptions: Subscription = new Subscription();
  configuredProperties: any;
  userselectedchartdata: any;
  ngOnInit(): void {
    if (this.isOutput) {
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
      if (!this.multiFunnelPopup) {
        this._customSnapshotService.getSelectedBrand(this.id).subscribe((selectedBrand) => {
          this.selectedBrand = selectedBrand;
          if (this.selectedBrand != undefined || this.selectedBrand != "") {
            this.plotChart(
              'chart-container' + this.id,
              this.customData,
              this.chartproperties
            );
          }
        });
      } else {
        // For multiFunnelPopup, selectedBrand is passed as @Input, load properties and plot
        this.http.get<any>('assets/Data/funnelchartData.json').subscribe((data) => {
          this.jsondata = data[0];
          this.chartproperties = this.jsondata['properties'][0];
          this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
          this.chartproperties.decimalRoundOff = 2;
          this.seriescolor = this.uniquechartservice.color;
          this.seriesgradientcolor = this.uniquechartservice.linearGradients1;
          this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
          this.plotChart(
            'chart-container' + this.id,
            this.customData,
            this.chartproperties
          );
        });
      }
    }
    else {
      this.http.get<any>('assets/Data/funnelchartData.json').subscribe((data) => {
        console.log("funnelchartcustomdata", this.customData);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties.decimalRoundOff = 2;
        this.seriescolor = this.uniquechartservice.color;
        this.seriesgradientcolor = this.uniquechartservice.linearGradients1;
        this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.plotChart(
          'chart-container' + this.id,
          this.jsondata['data'],
          this.chartproperties
        );
      });
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
      this.ngOnInit();
    }
  }

  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/funnelchartData.json').subscribe((data) => {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        this.seriescolor = this.uniquechartservice.color;
        this.seriesgradientcolor = this.uniquechartservice.linearGradients1;
        this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'right';
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
        this.plotChart(
          'chart-container' + this.id,
          this.jsondata['data'],
          this.chartproperties
        );
      }));
  }

  @Input() selectedBrand: any = "";
  brandList: any = [];
  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
    let i = 0;
    const isAudienceSnapshot = this._configService.selectedSnapshotType.toLowerCase().includes('audience') && this._configService.multiCohort;
    const isMultiBrand = this._configService.selectedSnapshotType.toLowerCase().includes('multi');
    
    console.log('preparemainChartData - isAudienceSnapshot:', isAudienceSnapshot);
    console.log('preparemainChartData - isMultiBrand:', isMultiBrand);
    console.log('preparemainChartData - multiCohort:', this._configService.multiCohort);
    console.log('preparemainChartData - sample colChild:', data?.metric_value?.[0]?.data?.[0]?.colChild);
    
    if (isMultiBrand || isAudienceSnapshot) {

      this.brandList = [];
      data.metric_value[0].data.forEach((d: any) => {
        // For audience snapshot, extract the audience name from colChild (e.g., "Audience|Gender|Male" -> "Male")
        if (isAudienceSnapshot && d.colChild && d.colChild.includes('|')) {
          const parts = d.colChild.split('|');
          const audienceName = parts[parts.length - 1]; // Get the last part
          if (!this.brandList.includes(audienceName)) {
            this.brandList.push(audienceName);
          }
        } else {
          this.brandList.push(d.colChild);
        }
      });
      if (this.brandList.length > 0) {
        if (this.selectedBrand == undefined || this.selectedBrand == "") { this.selectedBrand = this.brandList[0]; }
        this._customSnapshotService.updateBrandList(this.id, this.brandList, this.selectedBrand);
      }
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          // For audience snapshot, match by the last part of colChild
          const matchValue = isAudienceSnapshot && dataArr.colChild && dataArr.colChild.includes('|') 
            ? dataArr.colChild.split('|').pop() 
            : dataArr.colChild;
          if (matchValue == this.selectedBrand) {
            let d1 = {
              "Series Name": lev2.option,
              "Category Name": lev2.metric_group,
              "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
              "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
              "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
              "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
              "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
              "Change value vs PY": dataArr.changeVsPY,
              "Significance": "-1",
              "Sample size": dataArr.baseValueforLSorIs,
              "Significance2": "1",
              "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
              "Sig_LowerLimt": this.Sig_LowerLimt,
              "Sig_UpperLimt": this.Sig_UpperLimt,
              "Significance_Value": dataArr.Significance_Value
            }
            this.chartMainData.push(d1);
           }
        });
      });
    }
    else {
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.option,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }

  customization(): Observable<any[]> { //"Funnel Chart "
    // let custom = this.uniquechartservice.FunnelChartCustomizationList();
    // return custom;
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return this._customSnapshotService.getChartCustomization("Funnel Chart ", snapshotTypeSelectedName, cohortType);
  }

  arrangeArrayDescending(data: any[]): any[] {
    data.sort((a, b) => {
      const valueA = parseFloat(a['Rounded Value']);
      const valueB = parseFloat(b['Rounded Value']);

      // Handle null values
      if (isNaN(valueA) && isNaN(valueB)) {
        return 0; // Both are null, keep their relative order
      }
      if (isNaN(valueA)) {
        return 1; // Null should come after any number
      }
      if (isNaN(valueB)) {
        return -1; // Null should come after any number
      }

      // Handle 0 values
      if (valueA === 0 && valueB === 0) {
        return 0; // Both are 0, keep their relative order
      }
      if (valueA === 0) {
        return 1; // 0 should come after any other number
      }
      if (valueB === 0) {
        return -1; // 0 should come after any other number
      }

      // Sort in descending order of Rounded Value
      return valueB - valueA;
    });

    return data;
  }

  chart: any;
  seriesdata: any;
  xaxis: any = [];
  // preparechartdata(data: any, islowsample: any, isgradient: any) {
  //   let seriesdata: any[] = [];
  //   let xaxis: any = [];
  //   let i = 0;
  //   let data1 = this.arrangeArrayDescending(data);
  //   let maxdatapoint = parseFloat(data1[0]['Rounded Value']);
  //   let series1: any = {
  //     name: 'Other',
  //     data: [],
  //     borderWidth: 0,
  //     shadow: false,
  //   };
  //   let series2: any = {
  //     name: data[0]['Series Name'],
  //     data: [],
  //   };
  //   let series3: any = {
  //     name: 'Other',
  //     data: [],
  //     borderWidth: 0,
  //     shadow: false,
  //   };
  //   data1.forEach((dat: any) => {
  //     let value =
  //       isNaN(parseFloat(dat['Value'])) ||
  //       parseFloat(dat['Value']) == null
  //         ? null
  //         : parseFloat(dat['Value']);
  //     let finalvalue = !islowsample
  //       ? value
  //       : parseFloat(dat['Sample size']) > this.samplesizeconstant
  //       ? value
  //       : 0;
  //     xaxis.push(dat['Series Name']);
  //     let s1 = {
  //       name: 'Others',
  //       y: (maxdatapoint - (finalvalue == null ? 0 : finalvalue)) / 2,
  //       color: 'transparent',
  //       dataLabels: { enabled: false },
  //     };
  //     let s2 = {
  //       name: dat['Series Name'],
  //       y:  Number(parseFloat(finalvalue == null ? '0' : finalvalue.toString()).toFixed(this.chartproperties.decimalRoundOff)),
  //       y1: Number(parseFloat(finalvalue == null ? '0' : finalvalue.toString()).toFixed(this.chartproperties.decimalRoundOff)),
  //       actualcolor:this.seriescolor[i],
  //       color: !isgradient
  //         ? this.seriescolor[i++]
  //         : this.seriesgradientcolor[i++],
  //       samplesize: dat['Sample size'],
  //       cov: dat['Change value vs PY'],
  //       significance: dat['Significance'],
  //       significance2: dat['Significance2'],
  //       tooltip: '',
  //     };
  //     let s3 = {
  //       name: 'Others',
  //       y: (maxdatapoint - (finalvalue == null ? 0 : finalvalue)) / 2,
  //       color: 'transparent',
  //       dataLabels: { enabled: false },
  //     };
  //     series1.data.push(s1);
  //     series2.data.push(s2);
  //     series3.data.push(s3);
  //   });
  //   seriesdata = [series1, series2, series3];
  //   this.seriesdata = seriesdata;
  //   this.xaxis = xaxis;
  // }

  preparechartdata(data: any, islowsample: any, isgradient: any) {
    if (this.isOutput) {
      let seriesdata: any[] = [];
      let xaxis: any = [];
      let i = 0;
      // let data1 = this.arrangeArrayDescending(data);
      let data1 = data;

      const valuesArray = data.map((item: any) => item.Value);
      const valuesArray2 = data.map((item: any) => ({
        value: item.Value != null || NaN
          ? item.Value : 'NA',
        samplesize: item["Sample size"]
      }));
      const valuesArray1 = valuesArray2.map((item: any) =>
        this._configService.CheckLSorIScondition(this._configService.userRole, item.value, item.samplesize)
      );
      // ;
      let diff = valuesArray1.slice(1).map((currentValue: any, index: any) => {
        currentValue = currentValue.toString();
        let previousValue = valuesArray1[index].toString();
        
        switch (true) {
          case (Math.round(currentValue).toString() === '0' && previousValue.toString() == 'I/S'):
            return '0';
          case (Math.round(currentValue).toString() === '0' && Math.round(previousValue).toString() === '0'):
          case (Math.round(currentValue).toString() === '0' && previousValue.toString() === 'NA'):
          case (currentValue.toString() === 'NA' && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString() === 'NA' && previousValue.toString() === 'I/S'):
            return 'NA';
          case (Math.round(currentValue).toString() === '0' && !isNaN(previousValue.toString())):
          case (Math.round(currentValue).toString() === '0' && previousValue.toString().includes('*')):
            return '0';
          case (currentValue.toString() === 'NA' && !isNaN(previousValue.toString())):
          case (currentValue.toString() === 'NA' && previousValue.toString().includes('*')):
            return 'NA';

          case (currentValue.toString() === 'I/S' && Math.round(previousValue).toString() === '0'):
            return 'NA';
          case (currentValue.toString() === 'I/S' && previousValue.toString() === 'I/S'):
            return 'I/S';

          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString().includes('*') && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString().includes('*') && currentValue.toString().match(/\d+(\.\d+)?/)![0] == "0"):
            return 'NA';

          case (currentValue.toString() === 'I/S' && previousValue.toString() === 'NA'):
            return 'NA';
          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'NA'):
          case (currentValue.toString().includes('*') && previousValue.toString() === 'NA'):
            return 'NA';
          case (currentValue.toString() === 'NA' || previousValue.toString() === 'NA'):
            return 'NA';
          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'I/S'):
            return 'I/S';
          case (currentValue.toString().includes('*') && previousValue.toString() === 'I/S'):
            return 'I/S';
          case (currentValue.toString() === 'I/S' && !isNaN(previousValue.toString())):
            return Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100;
          case (currentValue.toString() === 'I/S' && previousValue.toString().includes('*')):
            previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
            return Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100 + "*";
          default:
            currentValue = /\d+(\.\d+)?/.test(currentValue.toString()) ? currentValue.toString().match(/\d+(\.\d+)?/)![0] : currentValue.toString();
            previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
            let answer = (Number(parseFloat(currentValue).toFixed(this.chartproperties?.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties?.decimalRoundOff))) * 100;
            return Number.isNaN(answer) ? "NA" : answer;
        }
        // if (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
        //   return 0;
        // } else if (Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
        //   return "NA";
        // } else {
        //   return (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff))) * 100;
        // }
      });

      diff = diff.filter((item: any) => {
        return item != undefined
      })

        ;
      let roundedValues = data1.map(function (item: any) {
        return item['Rounded Value'];
      });
      // console.log("conversion values",diff);
      // const pairedDiffs = diff.map((d: any, idx: number) => {
      //   const prev = data1[idx]?.['Series Name'] ?? '';
      //   const curr = data1[idx + 1]?.['Series Name'] ?? '';
      //   return `${prev}   :  ${curr}  :  ${d}`;
      // });
      // console.log('pairedDiffs', pairedDiffs);
      const startTime = performance.now();
      // build array of "previous_current_diff" for every brand available
      const widgetName = this.widgetName || '';

      // helper: build a chartMain-like array for a specific brand using same structure as preparemainChartData
      const isAudienceSnapshot = this._configService.selectedSnapshotType.toLowerCase().includes('audience') && this._configService.multiCohort;
      const buildChartMainDataForBrand = (brand: any) => {
        const temp: any[] = [];
        try {
          if (!this.customData || !this.customData.metric_value) { return temp; }
          this.customData.metric_value.forEach((lev2: any) => {
            lev2.data.forEach((dataArr: any) => {
              // For audience snapshot, match by the last part of colChild
              const matchValue = isAudienceSnapshot && dataArr.colChild && dataArr.colChild.includes('|') 
                ? dataArr.colChild.split('|').pop() 
                : dataArr.colChild;
              if (matchValue == brand) {
                temp.push({
                  "Series Name": lev2.option,
                  "Category Name": lev2.metric_group||lev2.option,
                  "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
                  "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
                  "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                  "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                  "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
                  "Change value vs PY": dataArr.changeVsPY,
                  "Significance": "-1",
                  "Sample size": dataArr.baseValueforLSorIs,
                  "Significance2": "1",
                  "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
                  "Sig_LowerLimt": this.Sig_LowerLimt,
                  "Sig_UpperLimt": this.Sig_UpperLimt,
                  "Significance_Value": dataArr.Significance_Value
                });
              }
            });
          });
        } catch (e) {
          // defensive: if customData shape differs, return empty
        }
        return temp;
      };

      // compute diff array for arbitrary data (reuses same rules as above)
      const computeDiffsForData = (arrData: any[]) => {
        if (!arrData || !arrData.length) { return []; }
        const valuesArray = arrData.map((item: any) => item.Value);
        const valuesArray2 = arrData.map((item: any) => ({
          value: item.Value != null || NaN ? item.Value : 'NA',
          samplesize: item["Sample size"]
        }));
        const valuesArray1 = valuesArray2.map((item: any) =>
          this._configService.CheckLSorIScondition(this._configService.userRole, item.value, item.samplesize)
        );
        let diffLocal = valuesArray1.slice(1).map((currentValue: any, index: any) => {
          currentValue = currentValue.toString();
          let previousValue = valuesArray1[index].toString();
          switch (true) {
            case (Math.round(currentValue).toString() === '0' && previousValue.toString() == 'I/S'):
              return '0';
            case (Math.round(currentValue).toString() === '0' && Math.round(Number(previousValue)).toString() === '0'):
            case (Math.round(currentValue).toString() === '0' && previousValue.toString() === 'NA'):
            case (currentValue.toString() === 'NA' && Math.round(Number(previousValue)).toString() === '0'):
            case (currentValue.toString() === 'NA' && previousValue.toString() === 'I/S'):
              return 'NA';
            case (Math.round(currentValue).toString() === '0' && !isNaN(Number(previousValue))):
            case (Math.round(currentValue).toString() === '0' && previousValue.toString().includes('*')):
              return '0';
            case (currentValue.toString() === 'NA' && !isNaN(Number(previousValue))):
            case (currentValue.toString() === 'NA' && previousValue.toString().includes('*')):
              return 'NA';
            case (currentValue.toString() === 'I/S' && Math.round(Number(previousValue)).toString() === '0'):
              return 'NA';
            case (currentValue.toString() === 'I/S' && previousValue.toString() === 'I/S'):
              return 'I/S';
            case (!currentValue.toString().includes("*") && !isNaN(Number(currentValue)) && Math.round(Number(previousValue)).toString() === '0'):
            case (currentValue.toString().includes('*') && Math.round(Number(previousValue)).toString() === '0'):
            case (currentValue.toString().includes('*') && currentValue.toString().match(/\d+(\.\d+)?/)![0] == "0"):
              return 'NA';
            case (currentValue.toString() === 'I/S' && previousValue.toString() === 'NA'):
              return 'NA';
            case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'NA'):
            case (currentValue.toString().includes('*') && previousValue.toString() === 'NA'):
              return 'NA';
            case (currentValue.toString() === 'NA' || previousValue.toString() === 'NA'):
              return 'NA';
            case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'I/S'):
              return 'I/S';
            case (currentValue.toString().includes('*') && previousValue.toString() === 'I/S'):
              return 'I/S';
            case (currentValue.toString() === 'I/S' && !isNaN(Number(previousValue))):
              return Number(parseFloat(valuesArray2[index - 1].value).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100;
            case (currentValue.toString() === 'I/S' && previousValue.toString().includes('*')):
              previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
              return Number(parseFloat(valuesArray2[index - 1].value).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100 + "*";
            default:
              currentValue = /\d+(\.\d+)?/.test(currentValue.toString()) ? currentValue.toString().match(/\d+(\.\d+)?/)![0] : currentValue.toString();
              previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
              let answer = (Number(parseFloat(currentValue).toFixed(this.chartproperties?.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties?.decimalRoundOff))) * 100;
              return Number.isNaN(answer) ? "NA" : answer;
          }
        });
        return diffLocal.filter((item: any) => item != undefined);
      };

      // determine brands to compute: use brandList if available, else fallback to selectedBrand
      const brandsToCompute = (this.brandList && this.brandList.length) ? this.brandList : (this.selectedBrand ? [this.selectedBrand] : []);
      const allResults: any[] = [];
      if (brandsToCompute.length === 0) {
        // no brand list available: keep existing behavior (use selected context / data1)
        const pairedDiffs = diff.map((d: any, idx: number) => {
          const prev = data1[idx]?.['Series Name'] ?? '';
          const curr = data1[idx + 1]?.['Series Name'] ?? '';
          return `${this.selectedBrand} : ${prev} : ${curr} : ${d}`;
        });
        allResults.push({ widget: widgetName, brand: this.selectedBrand ?? '', diffs: pairedDiffs });
      } else {
        for (const brand of brandsToCompute) {
          const dataForBrand = buildChartMainDataForBrand(brand);
          const diffsForBrand = computeDiffsForData.call(this, dataForBrand);
          const pairedForBrand = diffsForBrand.map((d: any, idx: number) => {
            const prev = dataForBrand[idx]?.['Series Name'] ?? '';
            const curr = dataForBrand[idx + 1]?.['Series Name'] ?? '';
            return `${brand} : ${prev} : ${curr} : ${d}`;
          });
          allResults.push({ widget: widgetName, brand, diffs: pairedForBrand });
        }
      }

      if (typeof window !== 'undefined') {
        (window as any)['conversion_values'] = allResults;
      }
      console.log('conversion values for all brands', allResults);

      const endTime = performance.now();
      console.log(`Conversion values computation took ${(endTime - startTime).toFixed(2)} milliseconds.`);
      let maxdatapoint = Math.max.apply(Math, roundedValues)+10;
      let maxdatapoint2 = Math.max(...diff);
      // let maxdatapoint = parseFloat(data1[0]['Rounded Value']);
      let series1: any = {
        name: 'Other',
        data: [],
        borderWidth: 0,
        shadow: false,
        pointPadding: 0,
        groupPadding: 0,
        // pointWidth:2
      };
      let series2: any = {
        name: data[0]['Series Name'],
        data: [],
        pointPadding: 0,

        groupPadding: 0,
        // pointWidth:2
      };
      let series3: any = {
        name: 'Other',
        data: [],
        borderWidth: 0,
        shadow: false,
        pointPadding: 0,
        groupPadding: 0,
        // pointWidth:2
      };
      data1.forEach((dat: any, index: number) => {
        let value =
          isNaN(parseFloat(dat['Rounded Value'])) ||
            parseFloat(dat['Rounded Value']) == null
            ? null
            : Number(parseFloat(dat['Value']).toFixed(this.chartproperties?.decimalRoundOff));
        let finalvalue: any = !islowsample
          ? value
          : parseFloat(dat['Sample size']) > this.samplesizeconstant
            ? value
            : 0;
        xaxis.push(dat['Series Name']);
        let s1 = {
          name: 'Others',
          y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 0 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
          color: '#f6f6f6',
          dataLabels: { enabled: false },
        };
        let s2 = {
          name: dat['Series Name'],
          y: this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue,
          indexValue: this._configService.CheckLSorIScondition(this._configService.userRole, dat['ValueForIndex']?.toString(), dat['Sample size']).includes("I/S") || dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'],
          actualIndexValue: dat['ActualIndexValue'],
          y1: finalvalue,
          actualcolor: this.seriescolor?.[i],
          conversion: diff[i],
          color: !isgradient
            ? this.seriescolor?.[i]
            : this.seriesgradientcolor[i],
          samplesize: dat['Sample size'],
          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          tooltip: '',
          isPercentage: dat["isPercentage"],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat['Significance_Value'],
          isLastSeries: index == data1.length - 1 ? true : false,
          dataLabels: {
              enabled: true,
              inside: false, // Place main value labels outside the bar
              align: 'center',
              x: 30, // Move label further outside if needed
              y: 0
            },
        };
        let s3 = {
          name: 'Others',
          y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 0 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
          color: '#f6f6f6',
          dataLabels: { enabled: false },
        };
        series1.data.push(s1);
        series2.data.push(s2);
        series3.data.push(s3);

        if (i < data1.length - 1) {
          let s11 = {
            name: 'Others',
            y: 0,
            y1: -1,
            color: 'transparent',
            dataLabels: { enabled: false },
            pointWidth: 0, // Reduced bar width
          };
          let s22 = {
            name: '',
            y: 1000,
            y1: -1,
            actualcolor: 'transparent',
            conversion: diff[i++],
            color: 'transparent',
            samplesize: dat['Sample size'],
            cov: dat['Change value vs PY'],
            significance: dat['Significance'],
            significance2: dat['Significance2'],
            tooltip: '',
            isPercentage: true,
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: dat['Significance_Value'],
            dataLabels: {
              enabled: true,
              inside: true, // Keep conversion labels inside the bar
              align: 'center',
              x: 0,
              y: 0
            },
            pointWidth: 0, // Further reduced bar width
          };
          let s33 = {
            name: 'Others',
            y: 0,
            y1: -1,
            color: 'transparent',
            dataLabels: { enabled: false },
            pointWidth: 0,
          };


          series1.data.push(s11);
          series2.data.push(s22);
          series3.data.push(s33);
          xaxis.push('');
        }

      });
      seriesdata = [series1, series2, series3];
      this.seriesdata = seriesdata;
      this.xaxis = xaxis;
      ;
    }
    else {
      let seriesdata: any[] = [];
      let xaxis: any = [];
      let i = 0;
      // let data1 = this.arrangeArrayDescending(data);
      let data1 = data;

      const valuesArray = data.map((item: any) => item.Value);
      const valuesArray2 = data.map((item: any) => ({
        value: item.Value != null || NaN
          ? item.Value : 'NA',
        samplesize: item["Sample size"]
      }));
      const valuesArray1 = valuesArray2.map((item: any) =>
        this._configService.CheckLSorIScondition(this._configService.userRole, item.value, item.samplesize)
      );
      // ;
      let diff = valuesArray1.slice(1).map((currentValue: any, index: any) => {
        currentValue = currentValue.toString();
        let previousValue = valuesArray1[index].toString();
        switch (true) {
          case (Math.round(currentValue).toString() === '0' && previousValue.toString() == 'I/S'):
            return '0';
          case (Math.round(currentValue).toString() === '0' && Math.round(previousValue).toString() === '0'):
          case (Math.round(currentValue).toString() === '0' && previousValue.toString() === 'NA'):
          case (currentValue.toString() === 'NA' && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString() === 'NA' && previousValue.toString() === 'I/S'):
            return 'NA';
          case (Math.round(currentValue).toString() === '0' && !isNaN(previousValue.toString())):
          case (Math.round(currentValue).toString() === '0' && previousValue.toString().includes('*')):
            return '0';
          case (currentValue.toString() === 'NA' && !isNaN(previousValue.toString())):
          case (currentValue.toString() === 'NA' && previousValue.toString().includes('*')):
            return 'NA';

          case (currentValue.toString() === 'I/S' && Math.round(previousValue).toString() === '0'):
            return 'NA';
          case (currentValue.toString() === 'I/S' && previousValue.toString() === 'I/S'):
            return 'I/S';

          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString().includes('*') && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString().includes('*') && currentValue.toString().match(/\d+(\.\d+)?/)![0] == "0"):
            return 'NA';

          case (currentValue.toString() === 'I/S' && previousValue.toString() === 'NA'):
            return 'NA';
          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'NA'):
          case (currentValue.toString().includes('*') && previousValue.toString() === 'NA'):
            return 'NA';
          case (currentValue.toString() === 'NA' || previousValue.toString() === 'NA'):
            return 'NA';
          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'I/S'):
            return 'I/S';
          case (currentValue.toString().includes('*') && previousValue.toString() === 'I/S'):
            return 'I/S';
          case (currentValue.toString() === 'I/S' && !isNaN(previousValue.toString())):
            return Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100;
          case (currentValue.toString() === 'I/S' && previousValue.toString().includes('*')):
            previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
            return Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100 + "*";
          default:
            currentValue = /\d+(\.\d+)?/.test(currentValue.toString()) ? currentValue.toString().match(/\d+(\.\d+)?/)![0] : currentValue.toString();
            previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
            let answer = (Number(parseFloat(currentValue).toFixed(this.chartproperties?.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff))) * 100;
            return Number.isNaN(answer) ? "NA" : answer;
        }
        // if (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
        //   return 0;
        // } else if (Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
        //   return "NA";
        // } else {
        //   return (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff))) * 100;
        // }
      });

      diff = diff.filter((item: any) => {
        return item != undefined
      })
        //console.log(diff);
        ;
      let roundedValues = data1.map(function (item: any) {
        return item['Rounded Value'];
      });

      // Find the maximum value

      let maxdatapoint = Math.max.apply(Math, roundedValues)+10;
      let maxdatapoint2 = Math.max(...diff);
      // let maxdatapoint = parseFloat(data1[0]['Rounded Value']);
      let series1: any = {
        name: 'Other',
        data: [],
        borderWidth: 0,
        shadow: false,
        pointPadding: 0,
        groupPadding: 0,
        // pointWidth:2
      };
      let series2: any = {
        name: data[0]['Series Name'],
        data: [],
        pointPadding: 0,
        groupPadding: 0,
        // pointWidth:2
      };
      let series3: any = {
        name: 'Other',
        data: [],
        borderWidth: 0,
        shadow: false,
        pointPadding: 0,
        groupPadding: 0,
        // pointWidth:2
      };
      data1.forEach((dat: any, index: number) => {
        let value =
          isNaN(parseFloat(dat['Rounded Value'])) ||
            parseFloat(dat['Rounded Value']) == null
            ? null
            : Number(parseFloat(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
        let finalvalue: any = !islowsample
          ? value
          : parseFloat(dat['Sample size']) > this.samplesizeconstant
            ? value
            : 0;
        xaxis.push(dat['Series Name']);
        let s1 = {
          name: 'Others',
          y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 1000 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
          color: '#f6f6f6',
          dataLabels: { enabled: false },
        };
        let s2 = {
          name: dat['Series Name'],
          y: this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue,
          indexValue: this._configService.CheckLSorIScondition(this._configService.userRole, dat['ValueForIndex']?.toString(), dat['Sample size']).includes("I/S") || dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'],
          actualIndexValue: dat['ActualIndexValue'],
          y1: finalvalue,
          actualcolor: this.seriescolor[i],
          conversion: diff[i],
          color: !isgradient
            ? this.seriescolor[i]
            : this.seriesgradientcolor[i],
          samplesize: dat['Sample size'],
          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          tooltip: '',
          isPercentage: dat["isPercentage"],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat['Significance_Value'],
          isLastSeries: index == data1.length - 1 ? true : false,
          dataLabels: {
              enabled: true,
              inside: false,
              align: 'center',
              x: 30,
              y: 0
            },
        };
        let s3 = {
          name: 'Others',
          y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 1000 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
          color: '#f6f6f6',
          dataLabels: { enabled: false },
        };
        series1.data.push(s1);
        series2.data.push(s2);
        series3.data.push(s3);

        if (i < data1.length - 1) {
          let s11 = {
            name: 'Others',
            y: 0,
            y1: -1,
            color: 'transparent',
            dataLabels: { enabled: false },
            pointWidth: 0,
          };
          let s22 = {
            name: '',
            y: 1000,
            y1: -1,
            actualcolor: 'transparent',
            conversion: diff[i++],
            color: 'transparent',
            samplesize: dat['Sample size'],
            cov: dat['Change value vs PY'],
            significance: dat['Significance'],
            significance2: dat['Significance2'],
            tooltip: '',
            isPercentage: true,
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: dat['Significance_Value'],
            dataLabels: {
              enabled: true,
              inside: true,
              align: 'center',
              x: 0,
              y: 0
            },
            pointWidth: 0,
          };
          let s33 = {
            name: 'Others',
            y: 0,
            y1: -1,
            color: 'transparent',
            dataLabels: { enabled: false },
            pointWidth: 0,
          };

          //console.log((maxdatapoint2 - Number(parseFloat(diff[i]).toFixed(1))) / 2,Number(parseFloat(diff[i]).toFixed(1)),(maxdatapoint2 - Number(parseFloat(diff[i]).toFixed(1))) / 2)
          series1.data.push(s11);
          series2.data.push(s22);
          series3.data.push(s33);
          xaxis.push('');
        }

      });
      seriesdata = [series1, series2, series3];
      this.seriesdata = seriesdata;
      this.xaxis = xaxis;
      ;
    }
  }

  plotLines: any = [];
  // plotChart(containerId: any, jsondata: any, chartproperties: any) {
  //   const maxLabelCharacters = this.popUp ? 30 : 20;
  //   localStorage.setItem('properties', JSON.stringify(chartproperties));
  //   let samplesizeconstant = this.samplesizeconstant;
  //   HC_accessibility(Highcharts);
  //   this.preparechartdata(
  //     jsondata,
  //     chartproperties.datalabelStyle == 'ls',
  //     chartproperties.gradientBarColor
  //   );
  //   for (let i = 0; i < this.seriesdata[1].data.length; i++) {
  //     const plotLine: Highcharts.XAxisPlotLinesOptions = {
  //       value: i,
  //       width: 1,
  //       dashStyle: 'Dash',
  //     };

  //     this.plotLines.push(plotLine);
  //   }
  //   this.chart = Highcharts.chart(containerId, {
  //     chart: {
  //       type: 'bar',
  //       backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
  //       style:{
  //         fontFamily: this.uniquechartservice.textfont,
  //         }
  //     },
  //     title: {
  //       text: "",
  //       align: chartproperties.chartTitlePosition,
  //       verticalAlign: 'top',
  //       style: {
  //         color: chartproperties.darkTheme ? 'white' : 'black',
  //       },
  //     },
  //     xAxis: {
  //       categories: this.xaxis,
  //       min: 0,
  //       max: this.chartproperties.numberOfFunnelLevels - 1,
  //       scrollbar: {
  //         //enabled: this.xaxis.length>8?true:false,
  //         enabled: false,
  //         height: 6, // Adjust the height of the scrollbar as needed
  //         barBackgroundColor: '#0060FF',
  //         barBorderRadius: 5,
  //         barBorderWidth: 0,
  //         barBorderColor:  chartproperties.darkTheme ? '#333':'white',
  //         buttonBackgroundColor: chartproperties.darkTheme ? '#333':'white',
  //         buttonBorderWidth: 0,
  //         buttonArrowColor:chartproperties.darkTheme ? '#333':'white',
  //         buttonBorderRadius: 5,
  //         rifleColor: 'none',
  //         trackBackgroundColor:  chartproperties.darkTheme ? '#333':'white',
  //         trackBorderWidth: 0,
  //         trackBorderColor: 'black',
  //         trackBorderRadius: 5
  //       },
  //       labels: {
  //         useHTML: true,
  //         style: {
  //           //fontFamily: this.barService.textfont,
  //           // Add CSS styles for text overflow
  //           whiteSpace: 'nowrap',
  //           textOverflow: 'ellipsis',
  //           color: chartproperties.darkTheme ? 'white' : 'black',
  //           fontSize:"0.7rem"
  //         },
  //         formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {


  //           let labelContent = String(this.value);

  //           //// Limit the number of characters only if axis label orientation is vertical
  //           //if (properties.axisLabelOrientation === "vertical") {
  //           if (labelContent.length > maxLabelCharacters) {
  //             labelContent = labelContent.substring(0, maxLabelCharacters) + '...';
  //           }
  //           //}

  //           return `<div style="width:6.5rem;text-align:right"title="${String(this.value)}">${labelContent}</div>`;

  //         },



  //         overflow: 'justify', // Handle overflow with justification
  //         //rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
  //       },


  //       plotLines: chartproperties.horizontalErrorBar ? this.plotLines : [{}],
  //       gridLineWidth: chartproperties.gridlines ? 1 : 0,
  //       alternateGridColor: chartproperties.plotBands
  //         ? !chartproperties.darkTheme
  //           ? '#eeebed'
  //           : '#7f7f7f'
  //         : '',
  //     },
  //     yAxis: {
  //       min: 0,
  //       gridLineWidth: 0,
  //       visible: false,
  //     },
  //     legend: {
  //       enabled: false,
  //       reversed: true,
  //     },
  //     tooltip: {
  //       enabled: true,
  //       borderWidth: 0,
  //       useHTML: true,
  //       shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
  //       shadow: false,
  //       backgroundColor: 'rgba(0,0,0,0)',


  //       formatter: function (this: any):any {
  //         const pointWithMetric = this.point as {
  //           name?:any;
  //           parent?:any;
  //           actualcolor?:any,
  //           color?:any;
  //           y?: number;
  //           y1?:number;
  //           cov?: string;
  //           significance?: string;
  //           significance2?: string;
  //           samplesize?: number;
  //           tooltip?:any
  //         };
  //         if (this.color == 'transparent') {
  //           return false;
  //         }
  //         const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
  //         const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
  //         if(pointWithMetric.tooltip==""){pointWithMetric.tooltip=pointWithMetric.y1==null?'NA':pointWithMetric.y}

  //         let isDefaultTooltip = chartproperties.toolTipStyle;
  //         if (isDefaultTooltip == "style1") {
  //           const dotColor = pointWithMetric.actualcolor;
  //           const commonContent =
  //             `<div style="border-left: 5px solid `+dotColor+`; border-bottom: 5px solid `+dotColor+`; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
  //             `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
  //             `<span><strong>Series Name:</strong></span>Brands<br>` +
  //             `<span><strong>Category Name:</strong></span> ${pointWithMetric.name}<br>` +
  //             `<span><strong>Value:</strong></span> ${pointWithMetric.tooltip}`;
  //           return commonContent + '</div>';
  //         }
  //         else {
  //           const dotColor = pointWithMetric.actualcolor; // Get the series color

  //           const content =
  //             `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
  //             `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>`  +
  //             `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

  //           return content + '</div>';

  //         }



  //       },
  //    },
  //     plotOptions: {
  //       series: {
  //         animation: false,
  //         stacking: 'percent',
  //         borderWidth: chartproperties.border ? 2 : 0,
  //         borderColor: chartproperties.darkTheme ? 'white' : 'black',
  //         shadow: chartproperties.shadow
  //           ? {
  //               color: chartproperties.darkTheme?'white':'rgba(0, 0, 0, 0.5)',
  //               offsetX: 1,
  //               offsetY: 1,
  //               opacity: 0.5,
  //               width: 6,
  //             }
  //           : false,
  //         dataLabels: {
  //           crop: false,
  //           overflow: 'allow',
  //           enabled: chartproperties.showDataLabel,
  //           color:
  //             chartproperties.dataLabelColor == 'default'
  //               ? chartproperties.darkTheme
  //                 ? 'white'
  //                 : 'black'
  //               : chartproperties.dataLabelColor,
  //           align:
  //             chartproperties.dataLabelPosition == 'Center'
  //               ? 'center'
  //               : chartproperties.dataLabelPosition == 'Inside Base'
  //               ? 'left'
  //               : 'right',
  //           style: {
  //             fontSize: chartproperties.dataLabelSize,
  //             textOutline: 'none',
  //             fontWeight:"normal"
  //           },
  //           formatter: function (
  //             this: Highcharts.TooltipFormatterContextObject
  //           ): any {
  //             const pointWithMetric = this.point as {
  //               name?: any;
  //               color?: any;
  //               y?: number;
  //               y1?: number;
  //               cov?: string;
  //               significance?: string;
  //               significance2?: string;
  //               samplesize?: number;
  //               tooltip?: any;
  //             };
  //             let textcolor = chartproperties.darkTheme ? 'white' : 'black';
  //             if (chartproperties.datalabelStyle === 'default') {
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '')
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span>' +
  //                 text +
  //                 '</span> ' +
  //                 '<span style="opacity: 0.5"></span>'
  //               );
  //             } else if (chartproperties.datalabelStyle === 'change') {
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '') +
  //                     ' ' +
  //                     `<span span style="font-size: 80%;color:` +
  //                     (chartproperties.darkTheme ? 'white' : 'black') +
  //                     `">(` +
  //                     (Number(pointWithMetric.cov) > 0 ? '+' : '') +
  //                     `${pointWithMetric.cov} )</span>`
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
  //               );
  //             } else if (
  //               chartproperties.datalabelStyle === 'significance + changeVs'
  //             ) {
  //               const upwardTriangle = '\u25B2';
  //               const downwardTriangle = '\u25BC';
  //               let sig = Number(pointWithMetric.significance);
  //               let s =
  //                 sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
  //               let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '') +
  //                     ' ' +
  //                     `<span span style="font-size: 80%;color:` +
  //                     (chartproperties.darkTheme ? 'white' : 'black') +
  //                     `">(` +
  //                     (Number(pointWithMetric.cov) > 0 ? '+' : '') +
  //                     `${pointWithMetric.cov} )</span>` +
  //                     '<span style="color:' +
  //                     sigcolor +
  //                     ';">' +
  //                     s +
  //                     '</span>'
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
  //               );
  //             } else if (chartproperties.datalabelStyle === 'significance') {
  //               const upwardTriangle = '\u25B2';
  //               const downwardTriangle = '\u25BC';
  //               let sig = Number(pointWithMetric.significance);
  //               let s =
  //                 sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
  //               let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '') +
  //                     '<span style="color:' +
  //                     sigcolor +
  //                     ';">' +
  //                     s +
  //                     '</span>'
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
  //               );
  //             } else if (chartproperties.datalabelStyle === 'ls') {
  //               let text =
  //                 Number(pointWithMetric.samplesize) > samplesizeconstant
  //                   ? pointWithMetric.y1 == null
  //                     ? 'NA'
  //                     : pointWithMetric.y +
  //                       (chartproperties.dataLabelFormat ? '%' : '')
  //                   : 'LS';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span>' +
  //                 text +
  //                 '</span> ' +
  //                 '<span style="opacity: 0.5"></span>'
  //               );
  //             } else if (chartproperties.datalabelStyle == 'significance2') {
  //               const upwardTriangle = '\u25B2';
  //               const downwardTriangle = '\u25BC';
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? this.y + (chartproperties.dataLabelFormat ? '%' : '')
  //                   : 'NA';
  //               let changeText = pointWithMetric.cov;
  //               let sig = Number(pointWithMetric.significance);
  //               let sig1 = Number(pointWithMetric.significance2);
  //               let sColor =
  //                 Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
  //               let s =
  //                 Number(sig) > 0
  //                   ? upwardTriangle
  //                   : Number(sig) < 0
  //                   ? downwardTriangle
  //                   : '';
  //               let changeColor =
  //                 sig1 < 0
  //                   ? 'red'
  //                   : sig1 > 0
  //                   ? 'green'
  //                   : chartproperties.darkTheme
  //                   ? 'white'
  //                   : 'black';
  //               if (Number(changeText) > 0) {
  //                 changeText = '+' + changeText;
  //               }
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span>' +
  //                 text +
  //                 (pointWithMetric.y1 != null && changeText
  //                   ? '&nbsp<span style="color:' +
  //                     ';"> ' +
  //                     '<span style="font-size: 80%; color:' +
  //                     changeColor +
  //                     ';">(' +
  //                     changeText +
  //                     ')</span> &nbsp' +
  //                     '<span style="color:' +
  //                     sColor +
  //                     ';">' +
  //                     s +
  //                     '</span>'
  //                   : '') +
  //                 '</span>'
  //               );
  //             }
  //             else{
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '')
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span>' +
  //                 text +
  //                 '</span> ' +
  //                 '<span style="opacity: 0.5"></span>'
  //               );
  //             }
  //           },
  //         },
  //       },
  //     },
  //     series: this.seriesdata,
  //     credits: {
  //       enabled: false,
  //     },
  //     exporting: {
  //       enabled: false,
  //     },
  //   }as Highcharts.Options);
  // }

  plotChart(containerId: any, jsondata: any, chartproperties: any) {
    let ht=this.height;
    let widgetCount =this.widgetCount;


  const getPaddingRightVal = function (grid: any) {
      let xdatalabelposition = 0;
      const screenHeight = window.innerHeight;

      if (grid === "49% 49%") { // Use `===` for comparison
        if (screenHeight <= 610) {
          xdatalabelposition = 5;
        } else if (screenHeight <= 800) {
          xdatalabelposition = 4.5;
        } else if (screenHeight <= 1200) {
          xdatalabelposition = 6;
        }
      } else {
        if (screenHeight <= 750) {
          xdatalabelposition = ht=="22em" ? 9.5 : widgetCount == 4 ? 5.2: 3.5;
        } else if (screenHeight <= 950) {
          xdatalabelposition = ht=="22em" ? 9.1 : widgetCount == 4 ? 5.8: 4.0;
        } else if (screenHeight <= 1200) {
          xdatalabelposition = ht=="22em" ? 11.4 : widgetCount == 4 ? 7.6 : 7.6;
        }
      }

      return xdatalabelposition;
    };
    // const getPaddingRightValforSigChange = function (grid: any) {
    //   let xdatalabelposition = 0;
    //   const screenHeight = window.innerHeight;

    //   if (grid === "49% 49%") { // Use `===` for comparison
    //     if (screenHeight <= 610) {
    //       xdatalabelposition = 70;
    //     } else if (screenHeight <= 800) {
    //       xdatalabelposition = 80;
    //     } else if (screenHeight <= 1200) {
    //       xdatalabelposition = 100;
    //     }
    //   } else {
    //     if (screenHeight <= 750) {
    //       xdatalabelposition = ht=="22em" ? 9.5 : 5.2;
    //     } else if (screenHeight <= 950) {
    //       xdatalabelposition = ht=="22em" ? 9.1 : 5.8; //2.3
    //     } else if (screenHeight <= 1200) {
    //       xdatalabelposition = ht=="22em" ? 11.4 : 7.6;
    //     }
    //   }

    //   return xdatalabelposition;
    // };

    const getPaddingRightValforSigChange = function (grid: any) {

      let xdatalabelposition = 0;
      const screenHeight = window.innerHeight;

      if (grid === "49% 49%") { // Use `===` for comparison
        if (screenHeight <= 610) {
          xdatalabelposition = 5;
        } else if (screenHeight <= 800) {
          xdatalabelposition = 4.5;
        } else if (screenHeight <= 1200) {
          xdatalabelposition = 6;
        }
      } else {

        if (screenHeight <= 650) {
          xdatalabelposition = ht=="22em" ? 9.5 : widgetCount == 4 ? 6.2: 4.5;
        } else if (screenHeight <= 950) {
          xdatalabelposition = ht=="22em" ? 9.1 : widgetCount == 4 ? 5.4: 4.0;
        } else if (screenHeight <= 1200) {
          xdatalabelposition = ht=="22em" ? 11.4 : widgetCount == 4 ? 9.6 : 7.6;
        }
      }

      return xdatalabelposition;
    };




    if (this.isOutput) {
      let gridTempleteColumns = this.gridTempleteColumns;
      let isXaxis = this.showXaxisLabels;
      const configService = this._configService;
      let multiFunnelPopup = this.multiFunnelPopup;
      localStorage.setItem('properties', JSON.stringify(chartproperties));
      let samplesizeconstant = this.samplesizeconstant;
      const maxLabelCharacters = this.popUp ? 35 : 25;
      HC_accessibility(Highcharts);
      this.preparemainChartData(this.customData);
      this.preparechartdata(
        this.chartMainData,
        chartproperties?.datalabelStyle == 'ls',
        chartproperties?.gradientBarColor
      );
      for (let i = 0; i < this.seriesdata[1].data.length; i++) {
        const plotLine: Highcharts.XAxisPlotLinesOptions = {
          value: i,
          width: 1,
          dashStyle: 'Dash',
        };

        this.plotLines.push(plotLine);
      }
      const popup = this.popUpp;
      const popUp = this.popUp;
      const snapshotTypeSelectedName = localStorage.getItem('snapshotselected_landing');

      this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
      chartproperties = this.chartproperties;
      const options: Highcharts.Options = {
        chart: {
          type: 'bar',
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
           marginTop:popUp?60:10,
           marginLeft: popUp?250:200, // Increased left margin for axis labels
          marginRight: 70, // Reduced right margin to minimize gap
          marginBottom: 20,
          style: {
            fontFamily: this.uniquechartservice.textfont,
            fontSize: '0.9rem',
            zIndex: 1,
            overflow: 'visible',
          },
          events: {
            load: function () {
              const chart = this;
              window.addEventListener('resize', function () {
                chart.reflow();
              });

              //#region wheel scroll
                const container = chart.container;
                const xAxis = chart.xAxis[0];

                function onWheel(e: any) {
                  e = e || window.event;
                  e.preventDefault();

                  // Normalize wheel delta
                  let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                  delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

                  const extremes = xAxis.getExtremes();
                  const step = 1; // how many categories to scroll at a time

                  let newMin = extremes.min + delta * step;
                  let newMax = extremes.max + delta * step;

                  // Bound checks
                  if (newMin < extremes.dataMin) {
                    newMin = extremes.dataMin;
                    newMax = newMin + (extremes.max - extremes.min);
                  }
                  if (newMax > extremes.dataMax) {
                    newMax = extremes.dataMax;
                    newMin = newMax - (extremes.max - extremes.min);
                  }

                  xAxis.setExtremes(newMin, newMax, true, false);
                }

                container.addEventListener('wheel', onWheel, {
                  passive: false,
                });
              //#endregion
            }
          }
        },
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
        xAxis: {
          lineWidth: 0,
          categories: [...this.xaxis, ''],
          min: 0,
          max: !this.multiFunnelPopup ? (this.popUp ? (this.xaxis.length > 11 ? 11 : this.xaxis.length - 1) : (this.xaxis.length > 10 ? 10 : this.xaxis.length - 1)) : this.xaxis.length - 1,
          scrollbar: {
      enabled: this.popUp
        ? (this.xaxis.length > 11 ? true : false)
        : (!this.multiFunnelPopup
          ? (this.xaxis.length > 10 ? (this.xaxis.length > 10 ? true : false) : false)
          : false),
            height: 5, // Adjust the height of the scrollbar as needed
            // barBackgroundColor: '#802AB7',
            margin:25,
            barBackgroundColor: '#7f7f7f',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBackgroundColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBorderWidth: 0,
            buttonArrowColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5
          },
          labels: {
            enabled: this.showXaxisLabels,
            useHTML: true,
            style: {
              //fontFamily: this.barService.textfont,
              color: chartproperties.darkTheme ? 'white' : 'black',
            },

            formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
              // Utilize the available marginLeft space more effectively
              const maxLabelWidth = popUp ? 230 : 180; // Use the full margin space available
              const availableWidth = maxLabelWidth - 20; // Account for padding
              let labelContent = String(this.value);
              
              // Create a temporary canvas context to measure text width
              const getTextWidth = (text: string, fontSize: string = '0.8em'): number => {
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                if (context) {
                  // Convert em to pixels (assuming 1em = 16px)
                  const fontSizePx = fontSize === '0.8em' ? '12.8px' : '16px';
                  context.font = `${fontSizePx} Arial, sans-serif`;
                  return context.measureText(text).width;
                }
                return text.length * 8; // Fallback estimation
              };
              
              // Function to break text into words based on actual width
              const breakIntoLines = (text: string): string[] => {
                const words = text.split(' ');
                const lines: string[] = [];
                let currentLine = '';
                
                for (const word of words) {
                  const testLine = currentLine ? `${currentLine} ${word}` : word;
                  const testWidth = getTextWidth(testLine);
                  
                  if (testWidth <= availableWidth) {
                    currentLine = testLine;
                  } else {
                    if (currentLine) {
                      lines.push(currentLine);
                      currentLine = word;
                    } else {
                      // Single word is too long, keep it as is
                      lines.push(word);
                    }
                  }
                }
                
                if (currentLine) {
                  lines.push(currentLine);
                }
                
                return lines;
              };
              
              const lines = breakIntoLines(labelContent);
              let displayLines: string[] = [];
              
              if (lines.length <= 2) {
                displayLines = lines;
              } else {
                // Take first line and combine rest into second line
                displayLines.push(lines[0]);
                const remainingText = lines.slice(1).join(' ');
                
                // Check if remaining text fits, if not truncate with ellipsis
                if (getTextWidth(remainingText) > availableWidth) {
                  let truncatedText = remainingText;
                  while (getTextWidth(truncatedText + '...') > availableWidth && truncatedText.length > 0) {
                    truncatedText = truncatedText.substring(0, truncatedText.length - 1);
                  }
                  displayLines.push(truncatedText + '...');
                } else {
                  displayLines.push(remainingText);
                }
              }
              
              // Check if second line needs truncation
              if (displayLines.length > 1 && getTextWidth(displayLines[1]) > availableWidth && !displayLines[1].endsWith('...')) {
                let secondLine = displayLines[1];
                while (getTextWidth(secondLine + '...') > availableWidth && secondLine.length > 0) {
                  secondLine = secondLine.substring(0, secondLine.length - 1);
                }
                displayLines[1] = secondLine + '...';
              }
              
              const lineHeight = '1.2em';
              const lineElements = displayLines.map((line, index) => 
                `<div style="line-height: ${lineHeight}; text-align: right; ">${line}</div>`
              ).join('');
              
              return `<div style="width: ${maxLabelWidth}px; text-align: right; word-wrap: break-word; overflow: hidden; padding-right: 10px;font-size:0.8em;" title="${labelContent}">${lineElements}</div>`;
            },

            overflow: 'justify', // Handle overflow with justification
            //rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
          },

          plotLines: chartproperties.horizontalErrorBar ? this.plotLines : [{}],
          gridLineWidth: chartproperties.gridlines ? 1 : 0,
          alternateGridColor: chartproperties.plotBands
            ? !chartproperties.darkTheme
              ? '#eeebed'
              : '#7f7f7f'
            : '',
        },
        yAxis: {
          min: 0,
          max: this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 100 : 100,
          //max:120,
          gridLineWidth: 0,
          visible: false,
        },
        legend: {
          enabled: false,
          reversed: true,
        },
        tooltip: {
           enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },


          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              actualcolor?: any,
              color?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;

            };
            
            // Disable tooltip for transparent colors and "Other"/"Others" series
            if (this.color == 'transparent' || 
                pointWithMetric.name === 'Other' || 
                pointWithMetric.name === 'Others' ||
                this.series.name === 'Other' ||
                this.series.name === 'Others') {
              return false;
            }
            
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.actualcolor;
              const content =
                  `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
            <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
            <span>${pointWithMetric.name}: </span>
            <b style="margin-left:4px;">${pointWithMetric.tooltip}</b>
          </div>`;
        return content;
            }
            else {
              const dotColor = pointWithMetric.actualcolor; // Get the series color

              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
                `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
                `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

              return content + '</div>';

            }



          },
        },
        plotOptions: {
          column: {
            pointPadding: 0,
            groupPadding: 0,
          },
          series: {
            animation: false,
            stacking: 'percent',
            borderWidth: chartproperties.border ? 2 : 0,
            borderColor: chartproperties.darkTheme ? 'white' : 'black',
            states: {
              hover: {
                enabled: true,
                halo: {
                  size: 0
                }
              },
              inactive: {
                enabled: false
              }
            },
            shadow: chartproperties.shadow
              ? {
                  color: 'rgba(0, 0, 0, 0.5)',
                  offsetX: 1,
                  offsetY: 1,
                  opacity: 0.5,
                  width: 6,
                }
              : false,
            dataLabels: {
              x: 0,
              y: 0,
              useHTML: true,
              crop: false,
              overflow: 'allow',
              enabled: chartproperties.showDataLabel,
              color:
                chartproperties.dataLabelColor == 'default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
              align: 'center', // Always center
              style: {
              fontSize: chartproperties.dataLabelSize
              ? `${parseFloat(chartproperties.dataLabelSize) - 0.1}em`
                : '0.6em',

                textOutline: 'none',
                fontWeight: "normal",
                textAlign: 'center' // Also center for HTML
              },
              
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ): any {
                const pointWithMetric = this.point as {
                  name?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  significance2?: string;
                  samplesize?: number;
                  tooltip?: any;
                  options?: any;
                  isPercentage?: any;
                  conversion?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any;
                  actualIndexValue?: any;
                  isLastSeries?: any;
                };
                let textcolor = chartproperties.darkTheme ? 'white' : 'black';
                let paddingRightVal = 0;
                // Add extra right padding for the last visible bar to avoid overlap with scrollbar
                const xAxis = this.series && this.series.xAxis ? this.series.xAxis : null;
                const isLastBar = xAxis && typeof this.x === 'number' && this.x === xAxis.max;
                if (isLastBar) {
                  paddingRightVal = 32; // px, adjust as needed for your UI
                }
                if (chartproperties.datalabelStyle === 'datalabel') {
                  let text =
                    pointWithMetric.y1 != null || NaN
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  text = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                  let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  pointWithMetric.tooltip = text;

                  let numericValue = parseFloat(text.replace('%', ''));
                  // paddingRightVal = pointWithMetric.name != "" ? 0 : (!multiFunnelPopup ? (popUp ? (snapshotTypeSelectedName == "Single Brand" ? 9.5 : 7) : getPaddingRightVal(gridTempleteColumns.trim())) : !isXaxis ? 4.3 : 3.6);
                  paddingRightVal=0;
                  if (con != "NaN" && pointWithMetric.name == "") {
                    return (
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div>'
                    );
                  }
                  else if (con == "NaN" && pointWithMetric.name == "") {
                    // paddingRightVal += 0.35;
                    return (
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div>'
                    );
                  }
                  else if (text == "0%" && pointWithMetric.name != "") {
                    console.log("yes its 0")
                    const screenHeight = window.innerHeight;
                    // if (screenHeight <= 610) { //150%
                    //   paddingRightVal += 1.5;
                    // }
                    // else if (screenHeight <= 800) {
                    //   paddingRightVal += 1.35;
                    // }
                    // else if (screenHeight <= 1200) {
                    //   paddingRightVal += 2;
                    // }
                    // paddingRightVal += 1.35;
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else {
                    return ('<div style="padding-right:' + (text == "NA" ? '0' : paddingRightVal) + 'px;">' +
                      text +
                      '</div> ');
                  }

                }
                else if (chartproperties.datalabelStyle === "index") {

                  let text =
                    pointWithMetric.y1 != null || NaN
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  text = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                  // let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  // pointWithMetric.tooltip = text;

                  // let numericValue = parseFloat(text.replace('%', ''));
                  // let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y : serviceBar.nullValueText;
                  // if (text == "0") {
                  //   text = "NA";
                  // }
                  // let color = configService.CheckIndexColoring(text);
                  // //// ;
                  // this.series.userOptions.tooltip[this.point.x - 1] = text;
                  // return (
                  //   '<span style="color:' + color + ';">' + text + '</span>'
                  // );

                  // paddingRightVal = pointWithMetric.name != "" ? 0 : popup ? 90 : 50;
                  // if(pointWithMetric.y1==0){
                  //   paddingRightVal+=35
                  // }



                  // let text2 = pointWithMetric.y1==0?'NA':pointWithMetric.y1 == -1 ? -1 :
                  //   pointWithMetric.y1 != null
                  //     ? pointWithMetric.indexValue.toFixed(1)
                  //     : 'NA';
                  let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y1 == -1 ? -1 :
                    pointWithMetric.y1 != null
                      ? pointWithMetric.indexValue.toFixed(1)
                      : 'NA';
                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  //text2 = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text2 + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                  let color = configService.CheckIndexColoring(String(text2));
                  pointWithMetric.tooltip = text + "(" + text2 + ")";

                  let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                 // pointWithMetric.tooltip = text + "(" + text2 + ")";

                  // paddingRightVal = pointWithMetric.name != "" ? 0 : (!multiFunnelPopup ? (popUp ? 7 : getPaddingRightValforSigChange(gridTempleteColumns.trim())) : !isXaxis ? 4.3 : 3.2);

                  // let popupPadding = 100;
                  // if (popUp) {
                  //   const screenHeight = window.innerHeight;
                  //   if (screenHeight <= 610) { //150%
                  //     popupPadding = 100
                  //   }
                  //   else if (screenHeight <= 800) {
                  //     popupPadding = 110
                  //   }
                  //   else if (screenHeight <= 1200) {
                  //     popupPadding = 120
                  //   }
                  // }
                  // paddingRightVal = pointWithMetric.name != "" ? 0 : (!multiFunnelPopup ? (popUp ? 7 : getPaddingRightValforSigChange(gridTempleteColumns.trim())) : !isXaxis ? 6.2 : 5.2);
                  paddingRightVal=0;
                  // if(pointWithMetric.tooltip.length>10){
                  //   paddingRightVal=-80
                  // }
                  if (con != "NaN" && pointWithMetric.name == "") {
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '<br>' +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else if (con != "NaN" || pointWithMetric.options.isLastSeries != false) {
                    return (
                      '<span>' +
                      text + 
                      '&nbsp<br><span style="color:' + (pointWithMetric.name === "" ? 'white' : color) + ';">(' + text2 + ')</span>' +
                      '</span>'
                    );
                  }
                  else {
                    return (
                      '<span>' +
                      text + 
                      '&nbsp<br><span style="color:' + (pointWithMetric.name == "" ? 'white' : color) + ';">(' + text2 + ')</span>' +
                      '</span>'
                    );

                  }
                  // return (
                  //   '<span style:"color:' + color + ';">' + text + '</span>'
                  // );

                }
                else if (chartproperties.datalabelStyle === 'sigChange') {
                  let textCheck = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, pointWithMetric.y1 + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y1), Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y1), Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                  if (pointWithMetric.name == '') {
                    let text = textCheck;


                    pointWithMetric.tooltip = text;
                    // let popupPadding = 100;
                    // if (popUp) {
                    //   const screenHeight = window.innerHeight;
                    //   if (screenHeight <= 610) { //150%
                    //     popupPadding = 100
                    //   }
                    //   else if (screenHeight <= 800) {
                    //     popupPadding = 110
                    //   }
                    //   else if (screenHeight <= 1200) {
                    //     popupPadding = 120
                    //   }
                    // }

                    //let numericValue = parseFloat(text.replace('%', ''));
                   // paddingRightVal = pointWithMetric.name != "" ? 0 : !multiFunnelPopup ? (popUp ? popupPadding : getPaddingRightValforSigChange(gridTempleteColumns.trim())) : !isXaxis ? 65 : 56;
                  //  paddingRightVal = pointWithMetric.name != "" ? 0 : !multiFunnelPopup ? (popUp ? popupPadding : getPaddingRightValforSigChange(gridTempleteColumns.trim())) : !isXaxis ? 65 : 56;
                    // paddingRightVal = pointWithMetric.name != "" ? 0 : (!multiFunnelPopup ? (popUp ? 7 : getPaddingRightValforSigChange(gridTempleteColumns.trim())) : !isXaxis ? 5.4 : 4.5);
                    paddingRightVal=0;
                    // if (text == "NA") {
                    //   paddingRightVal += 10
                    // }
                    return (
                      '<div style="padding-right:' + (paddingRightVal) + 'rem; color:' + textcolor + '; ">' + text + '</div>'
                    );
                  }
                  else {
                    let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                    let sigClass = pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                    if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                      let text = textCheck +
                        // pointWithMetric.y1 != null
                        //   ? pointWithMetric.y +
                        //   (pointWithMetric.isPercentage ? '%' : '') +
                        '<span style="color:' +
                        sigClass +
                        ';font-size:80%;"> (NA)</span>';

                      pointWithMetric.tooltip = text;
                      if (pointWithMetric.y1 == 0) {
                        const screenHeight = window.innerHeight;
                        // if (screenHeight <= 610) { //150%
                        //   if (popUp) {
                        //     paddingRightVal = 3.3
                        //   }
                        //   else {
                        //     paddingRightVal = 2.5
                        //   }
                        // }
                        // else if (screenHeight <= 800) {
                        //   paddingRightVal = 1.8
                        // }
                        // else if (screenHeight <= 1200) {
                        //   if (popUp) {
                        //     paddingRightVal = 2.4
                        //   }
                        //   else {
                        //     paddingRightVal = 1.3
                        //   }
                        // }
                      }
                      else {
                        paddingRightVal = 0
                      }
                      return (
                        '<div style="color:' + textcolor + ';padding-right:' + paddingRightVal + 'rem;">' + text + '<br></div>'
                      );
                    }
                    else {
                      let text = textCheck + ' ' +
                        // pointWithMetric.y1 != null
                        //   ? pointWithMetric.y +
                        //   (pointWithMetric.isPercentage ? '%' : '') +
                        (textCheck != 'I/S' ? ('<span style="color:' +
                          sigClass +
                          '; font-size:80%"><br>(' +
                          ((changeVal.toFixed(1)) + (pointWithMetric.isPercentage ? '%' : '')) +
                          ')</span>') : '');

                      pointWithMetric.tooltip = text;
                      if (pointWithMetric.y1 == 0) {
                        // paddingRightVal = 1
                        console.log("else block")
                      }
                      else {
                        paddingRightVal = 0
                      }
                      return (
                        '<div style="color:' + textcolor + ';padding-right:' + (paddingRightVal) + 'rem;">' + text + '<br></div>'
                      );
                    }
                  }



                  // return "hi"
                }
                else if (chartproperties.datalabelStyle === 'change') {
                  let mainValue =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  let changeVs =
                    pointWithMetric.y1 != null
                      ? `<span style="font-size: 80%; color: ${chartproperties.darkTheme ? 'white' : 'black'};">(${pointWithMetric.cov})</span>`
                      : '';
                  pointWithMetric.tooltip = mainValue + (changeVs ? ' ' + changeVs : '');
                  return (
                    '<div style="color:' + textcolor + ';">' + mainValue + (changeVs ? '<br>' + changeVs : '') + '</div>'
                  );
                } else if (
                  chartproperties.datalabelStyle === 'significance + changeVs'
                ) {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `">(` +
                      (Number(pointWithMetric.cov) > 0 ? '+' : '') +
                      `${pointWithMetric.cov} )</span>` +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'significance') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'ls') {
                  let text =
                    Number(pointWithMetric.samplesize) > samplesizeconstant
                      ? pointWithMetric.y1 == null
                        ? 'NA'
                        : pointWithMetric.y +
                        (chartproperties.dataLabelFormat ? '%' : '')
                      : 'LS';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    pointWithMetric.name +
                    '</span> <span>' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>'
                  );
                } else if (chartproperties.datalabelStyle == 'significance2') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let text =
                    pointWithMetric.y1 != null
                      ? this.y + (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  let changeText = pointWithMetric.cov;
                  let sig = Number(pointWithMetric.significance);
                  let sig1 = Number(pointWithMetric.significance2);
                  let sColor =
                    Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                  let s =
                    Number(sig) > 0
                      ? upwardTriangle
                      : Number(sig) < 0
                        ? downwardTriangle
                        : '';
                  let changeColor =
                    sig1 < 0
                      ? 'red'
                      : sig1 > 0
                        ? 'green'
                        : chartproperties.darkTheme
                          ? 'white'
                          : 'black';
                  if (Number(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    text +
                    (pointWithMetric.y1 != null && changeText
                      ? '&nbsp<br><span style="color:' +
                      ';"> ' +
                      '<span style="font-size: 80%; color:' +
                      changeColor +
                      ';">(' +
                      changeText +
                      ')</span> &nbsp' +
                      '<span style="color:' +
                      sColor +
                      ';">' +
                      s +
                      '</span>'
                      : '') +
                    '</span>'
                  );
                }
              },
            },
          },
        },
        series: this.seriesdata,

        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
      }
      Highcharts.chart('chart-container' + this.id, options);
    }
    else {
            let multiFunnelPopup = this.multiFunnelPopup;
            let popUp = this.popUp;
            let isXaxis = this.showXaxisLabels;
            const snapshotTypeSelectedName = localStorage.getItem('snapshotselected_landing');
             let gridTempleteColumns = this.gridTempleteColumns;
      const maxLabelCharacters = this.popUp ? 35 : 25;
      localStorage.setItem('properties', JSON.stringify(chartproperties));
      let samplesizeconstant = this.samplesizeconstant;
      HC_accessibility(Highcharts);
      this.preparechartdata(
        jsondata,
        chartproperties.datalabelStyle == 'ls',
        chartproperties.gradientBarColor
      );
      for (let i = 0; i < this.seriesdata[1].data.length; i++) {
        const plotLine: Highcharts.XAxisPlotLinesOptions = {
          value: i,
          width: 1,
          dashStyle: 'Dash',
        };

        this.plotLines.push(plotLine);
      }
      const options: Highcharts.Options = {
        chart: {
          type: 'bar',
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          marginTop:popUp?60:10,
          marginLeft: popUp?250:200,// Increased left margin for axis labels
          marginRight: 5, // Reduced right margin to minimize gap
          style: {
            fontFamily: this.uniquechartservice.textfont,
            fontSize: '0.7rem'
          },
          events: {
            load: function () {
              const chart = this;
              window.addEventListener('resize', function () {
                chart.reflow();
              });
              //#region wheel scroll
                const container = chart.container;
                const xAxis = chart.xAxis[0];

                function onWheel(e: any) {
                  e = e || window.event;
                  e.preventDefault();

                  // Normalize wheel delta
                  let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                  delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

                  const extremes = xAxis.getExtremes();
                  const step = 1; // how many categories to scroll at a time

                  let newMin = extremes.min + delta * step;
                  let newMax = extremes.max + delta * step;

                  // Bound checks
                  if (newMin < extremes.dataMin) {
                    newMin = extremes.dataMin;
                    newMax = newMin + (extremes.max - extremes.min);
                  }
                  if (newMax > extremes.dataMax) {
                    newMax = extremes.dataMax;
                    newMin = newMax - (extremes.max - extremes.min);
                  }

                  xAxis.setExtremes(newMin, newMax, true, false);
                }

                container.addEventListener('wheel', onWheel, {
                  passive: false,
                });
              //#endregion
            }
          }
        },
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
        xAxis: {
          lineWidth: 0,
          categories: this.xaxis,
          min: 0,
          max: this.chartproperties.numberOfFunnelLevels+this.chartproperties.numberOfFunnelLevels - 2,
          scrollbar: {
            enabled: false,
            height: 6, // Adjust the height of the scrollbar as needed
            barBackgroundColor: '#0060FF',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: chartproperties.darkTheme ? '#333' : 'white',
            buttonBackgroundColor: chartproperties.darkTheme ? '#333' : 'white',
            buttonBorderWidth: 0,
            buttonArrowColor: chartproperties.darkTheme ? '#333' : 'white',
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: chartproperties.darkTheme ? '#333' : 'white',
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5
          },
            labels: {
            enabled: this.showXaxisLabels,
            useHTML: true,
            style: {
              //fontFamily: this.barService.textfont,
              color: chartproperties.darkTheme ? 'white' : 'black',
            },

            formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
              // Utilize the available marginLeft space more effectively
              const maxLabelWidth = popUp ? 230 : 180; // Use the full margin space available
              const maxCharsPerLine = popUp ? 25 : 22; // More characters per line with full margin space
              let labelContent = String(this.value);
              
              // Function to break text into words without breaking words
              const breakIntoLines = (text: string): string[] => {
                const words = text.split(' ');
                const lines: string[] = [];
                let currentLine = '';
                
                for (const word of words) {
                  const testLine = currentLine ? `${currentLine} ${word}` : word;
                  
                  if (testLine.length <= maxCharsPerLine) {
                    currentLine = testLine;
                  } else {
                    if (currentLine) {
                      lines.push(currentLine);
                      currentLine = word;
                    } else {
                      // Single word is too long, keep it as is
                      lines.push(word);
                    }
                  }
                }
                
                if (currentLine) {
                  lines.push(currentLine);
                }
                
                return lines;
              };
              
              const lines = breakIntoLines(labelContent);
              let displayLines: string[] = [];
              
              if (lines.length <= 2) {
                displayLines = lines;
              } else {
                // Take first line and combine rest into second line
                displayLines.push(lines[0]);
                const remainingText = lines.slice(1).join(' ');
                
                if (remainingText.length > maxCharsPerLine) {
                  displayLines.push(remainingText.substring(0, maxCharsPerLine - 3) + '...');
                } else {
                  displayLines.push(remainingText);
                }
              }
              
              // If second line is too long, add ellipsis
              if (displayLines.length > 1 && displayLines[1].length > maxCharsPerLine && !displayLines[1].endsWith('...')) {
                displayLines[1] = displayLines[1].substring(0, maxCharsPerLine - 3) + '...';
              }
              
              const lineHeight = '1.2em';
              const lineElements = displayLines.map((line, index) => 
                `<div style="line-height: ${lineHeight}; text-align: right; ">${line}</div>`
              ).join('');
              
              return `<div style="width: ${maxLabelWidth}px; text-align: right; word-wrap: break-word; overflow: hidden; padding-right: 10px;" title="${labelContent}">${lineElements}</div>`;
            },

            overflow: 'justify', // Handle overflow with justification
            //rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
          },

          plotLines: chartproperties.horizontalErrorBar ? this.plotLines : [{}],
          gridLineWidth: chartproperties.gridlines ? 1 : 0,
          alternateGridColor: chartproperties.plotBands
            ? !chartproperties.darkTheme
              ? '#eeebed'
              : '#7f7f7f'
            : '',
        },
        yAxis: {
          min: 0,
          gridLineWidth: 0,
          visible: false,
        },
        legend: {
          enabled: false,
          reversed: true,
        },
        tooltip: {
           enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },


          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              actualcolor?: any,
              color?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;

            };
            
            // Disable tooltip for transparent colors and "Other"/"Others" series
            if (this.color == 'transparent' || 
                pointWithMetric.name === 'Other' || 
                pointWithMetric.name === 'Others' ||
                this.series.name === 'Other' ||
                this.series.name === 'Others') {
              return false;
            }
            
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
             console.log(isDefaultTooltip);
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.color;

              const content =
                  `<div style="background: transparent; border: none; border-radius: 8px; min-width: 220px; font-size: 0.8em; display: flex; align-items: center; ">
            <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
            <span>${pointWithMetric.name}: </span>
            <b style="margin-left:4px;">${pointWithMetric.tooltip}</b>
          </div>`;
        return content;
            }
            else {
              const dotColor = pointWithMetric.actualcolor; // Get the series color

              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
                `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
                `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

              return content + '</div>';

            }



          },
        },
        plotOptions: {
          column: {
            pointPadding: 0,
            groupPadding: 0,
          },
          series: {
            // pointPadding: 0.1,
            // groupPadding: 0.1,
            animation: false,
            stacking: 'percent',
            borderWidth: chartproperties.border ? 2 : 0,
            borderColor: chartproperties.darkTheme ? 'white' : 'black',
            states: {
              hover: {
                enabled: true,
                halo: {
                  size: 0
                }
              },
              inactive: {
                enabled: false
              }
            },
            shadow: chartproperties.shadow
              ? {
                color: 'rgba(0, 0, 0, 0.5)',
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 6,
              }
              : false,
            dataLabels: {
              x:0,
              // x: chartproperties.datalabelStyle == 'datalabel' ? 10 : chartproperties.datalabelStyle == 'index' ? 15 : 12,
              y: 0,
              useHTML: true,
              crop: false,
              overflow: 'allow',
              inside: false,
              verticalAlign: 'middle',
              enabled: chartproperties.showDataLabel,
              color:
                chartproperties.dataLabelColor == 'default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
              align:
                chartproperties.dataLabelPosition == 'Center'
                  ? 'center'
                  : chartproperties.dataLabelPosition == 'Inside Base'
                    ? 'left'
                    : 'right',
              style: {
                fontSize:chartproperties.dataLabelSize,
                textOutline: 'none',
                fontWeight: "normal"
              },
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ): any {
                const pointWithMetric = this.point as {
                  name?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  significance2?: string;
                  samplesize?: number;
                  tooltip?: any;
                  options?: any;
                  isPercentage?: any;
                  conversion?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any;
                  actualIndexValue?: any;
                  isLastSeries?: any;
                };
                let textcolor = chartproperties.darkTheme ? 'white' : 'black';
                let paddingRightVal = 0;
                if (chartproperties.datalabelStyle === 'datalabel') {
                  let text =
                    pointWithMetric.y1 != null || NaN
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                      text = pointWithMetric.name != ""
                      ? (text + (pointWithMetric.isPercentage ? '%' : ''))
                      : (!isNaN(pointWithMetric.conversion)
                          ? parseFloat(pointWithMetric.conversion).toFixed(1)
                          : pointWithMetric.conversion)
                      + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                  let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  pointWithMetric.tooltip = text;

                  let numericValue = parseFloat(text.replace('%', ''));
                //  paddingRightVal = pointWithMetric.name != "" ? 0 : (!multiFunnelPopup ? (popUp ? (snapshotTypeSelectedName == "Single Brand" ? 9.5 : 7) : getPaddingRightVal(gridTempleteColumns.trim())) : !isXaxis ? 4.3 : 3.6);
paddingRightVal=0;
                  if (con != "NaN" && pointWithMetric.name == "") {
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;left: -103px;position: relative;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else if (con == "NaN" && pointWithMetric.name == "") {
                    // paddingRightVal += 0.35;
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else if (text == "0%" && pointWithMetric.name != "") {
                    console.log("yes its 0")
                    const screenHeight = window.innerHeight;
                    // if (screenHeight <= 610) { //150%
                    //   paddingRightVal += 1.5;
                    // }
                    // else if (screenHeight <= 800) {
                    //   paddingRightVal += 1.35;
                    // }
                    // else if (screenHeight <= 1200) {
                    //   paddingRightVal += 2;
                    // }
                    // paddingRightVal += 1.35;
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else {
                    console.log('<div style="padding-right:' + (text == "NA" ? 0 : paddingRightVal) + 'px;">' +
                      text +
                      '</div> ')
                    return ('<div style="padding-right:' + (text == "NA" ? '0' : paddingRightVal) + 'px;">' +
                      text +
                      '</div> ');
                  }

                }
                else if (chartproperties.datalabelStyle === "index") {

                  let text =
                    pointWithMetric.y1 != null || NaN
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                      text = pointWithMetric.name != ""
                      ? (text + (pointWithMetric.isPercentage ? '%' : ''))
                      : (!isNaN(pointWithMetric.conversion)
                          ? parseFloat(pointWithMetric.conversion).toFixed(1)
                          : pointWithMetric.conversion)
                      + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                  // let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  // pointWithMetric.tooltip = text;

                  // let numericValue = parseFloat(text.replace('%', ''));
                  // let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y : serviceBar.nullValueText;
                  // if (text == "0") {
                  //   text = "NA";
                  // }
                  // let color = configService.CheckIndexColoring(text);
                  // //// ;
                  // this.series.userOptions.tooltip[this.point.x - 1] = text;
                  // return (
                  //   '<span style="color:' + color + ';">' + text + '</span>'
                  // );
                  // paddingRightVal = pointWithMetric.name != "" ? 0 :  90 ;
                  if(pointWithMetric.y1==0){
                    // paddingRightVal+=35
                  }



                  // let text2 = pointWithMetric.y1==0?'NA':pointWithMetric.y1 == -1 ? -1 :
                  //   pointWithMetric.y1 != null
                  //     ? pointWithMetric.indexValue.toFixed(1)
                  //     : 'NA';
                  let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y1 == -1 ? -1 :
                    pointWithMetric.y1 != null
                      ? pointWithMetric.indexValue.toFixed(1)
                      : 'NA';
                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  //text2 = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text2 + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                  let color = chartproperties.darkTheme ? 'white' : 'black';
                  pointWithMetric.tooltip = text + "(" + text2 + ")";

                  let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  pointWithMetric.tooltip = text + "(" + text2 + ")";
                  // if(pointWithMetric.tooltip.length>10){
                  //   paddingRightVal=-80
                  // }
                  if (con != "NaN" || pointWithMetric.options.isLastSeries != false) {
                    return (
                      '<div>' +
                      '<div style="color: ' + (pointWithMetric.name === "" ? 'white' : 'black') + '; padding-right: ' + paddingRightVal + 'px;">' +
                      text + '<br> (<span style="color:' + (pointWithMetric.name === "" ? 'white' : color) + ';">' + text2 + '</span>)' +
                      '</div>' +
                      '</div>'
                    );


                  }
                  else {
                    return (
                      '<div style="color: ' + (pointWithMetric.name == "" ? 'white' : color) + '; padding-right: ' + paddingRightVal + 'px;">' +
                      text + ' (' + text2 + ')' +
                      '</div>'
                    );

                  }
                  // return (
                  //   '<span style:"color:' + color + ';">' + text + '</span>'
                  // );

                }
                else if (chartproperties.datalabelStyle === 'sigChange') {
                  let textCheck = pointWithMetric.name != ""
    ? (pointWithMetric.y1 + (pointWithMetric.isPercentage ? '%' : ''))
    : (!isNaN(pointWithMetric.conversion)
        ? parseFloat(pointWithMetric.conversion).toFixed(1)
        : pointWithMetric.conversion)
    + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                  //paddingRightVal = pointWithMetric.name != "" ? 0 : 30;
                  if (pointWithMetric.name == '') {
                    let text = textCheck;
                    // pointWithMetric.y1 != null
                    //   ? pointWithMetric.y +
                    //   (pointWithMetric.isPercentage ? '%' : '')
                    //   : 'NA';
                    pointWithMetric.tooltip = text;
                    let popupPadding = 100;

                    let numericValue = parseFloat(text.replace('%', ''));
                    // paddingRightVal = pointWithMetric.name != "" ? 0 :  65 ;
                    if (text == "NA") {
                      // paddingRightVal += 10
                    }
                    return (
                      '<span style="padding-right:' + (paddingRightVal + 20) + 'px; color:' + textcolor + '; ">' + text + '</span>'
                    );
                  }
                  else {
                    let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                    let sigClass = pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                    if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                      let text = textCheck +
                        // pointWithMetric.y1 != null
                        //   ? pointWithMetric.y +
                        //   (pointWithMetric.isPercentage ? '%' : '') +
                        '<span style="color:' +
                        sigClass +
                        ';font-size:80%;"> (NA)</span>';

                      pointWithMetric.tooltip = text;
                      if (pointWithMetric.y1 == 0) {
                        const screenHeight = window.innerHeight;
                        if (screenHeight <= 610) { //150%


                            // paddingRightVal = 2.5

                        }
                        else if (screenHeight <= 800) {
                          // paddingRightVal = 1.8
                        }
                        else if (screenHeight <= 1200) {

                            // paddingRightVal = 1.3

                        }
                      }
                      else {
                        paddingRightVal = 0
                      }
                      return (
                        '<div style="color:' + textcolor + ';padding-right:' + paddingRightVal + 'rem;">' + text + '</div>'
                      );
                    }
                    else {
                      let text = textCheck + ' ' +
                        // pointWithMetric.y1 != null
                        //   ? pointWithMetric.y +
                        //   (pointWithMetric.isPercentage ? '%' : '') +
                        (textCheck != 'I/S' ? ('<span style="color:' +
                          sigClass +
                          '; font-size:80%"><br>(' +
                          ((changeVal.toFixed(1)) + (pointWithMetric.isPercentage ? '%' : '')) +
                          ')</span>') : '');

                      pointWithMetric.tooltip = text;
                      if (pointWithMetric.y1 == 0) {
                        // paddingRightVal = 1
                        console.log("else block")
                      }
                      else {
                        paddingRightVal = 0
                      }
                      return (
                        '<div style="color:' + textcolor + ';padding-right:' + (paddingRightVal) + 'rem;">' + text + '</div>'
                      );
                    }
                  }



                  // return "hi"
                }
                else if (chartproperties.datalabelStyle === 'change') {
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `">(` + `${pointWithMetric.cov} )</span>`
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (
                  chartproperties.datalabelStyle === 'significance + changeVs'
                ) {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `"><br>(` +
                      (Number(pointWithMetric.cov) > 0 ? '+' : '') +
                      `${pointWithMetric.cov} )</span>` +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'significance') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'ls') {
                  let text =
                    Number(pointWithMetric.samplesize) > samplesizeconstant
                      ? pointWithMetric.y1 == null
                        ? 'NA'
                        : pointWithMetric.y +
                        (chartproperties.dataLabelFormat ? '%' : '')
                      : 'LS';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    pointWithMetric.name +
                    '</span> <span>' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>'
                  );
                } else if (chartproperties.datalabelStyle == 'significance2') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let text =
                    pointWithMetric.y1 != null
                      ? this.y + (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  let changeText = pointWithMetric.cov;
                  let sig = Number(pointWithMetric.significance);
                  let sig1 = Number(pointWithMetric.significance2);
                  let sColor =
                    Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                  let s =
                    Number(sig) > 0
                      ? upwardTriangle
                      : Number(sig) < 0
                        ? downwardTriangle
                        : '';
                  let changeColor =
                    sig1 < 0
                      ? 'red'
                      : sig1 > 0
                        ? 'green'
                        : chartproperties.darkTheme
                          ? 'white'
                          : 'black';
                  if (Number(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    text +
                    (pointWithMetric.y1 != null && changeText
                      ? '&nbsp<span style="color:' +
                      ';"> ' +
                      '<span style="font-size: 80%; color:' +
                      changeColor +
                      ';"><br>(' +
                      changeText +
                      ')</span> &nbsp' +
                      '<span style="color:' +
                      sColor +
                      ';">' +
                      s +
                      '</span>'
                      : '') +
                    '</span>'
                  );
                }
              },
            },
          },
        },
        series: this.seriesdata,

        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
      }
      Highcharts.chart('chart-container' + this.id, options);
    }
  }
  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.uniquechartservice.applycustomization(event, item, this.chartproperties)
    this.plotChart(
      'chart-container' + this.id,
      this.jsondata['data'],
      this.chartproperties
    );
  }
  userselectedproperties() {
    this.jsondata['data'] = this.arrangeArrayDescending(this.jsondata['data']);
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }
}
